import { Parent_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';

const Page: FC = () => {
  const { t } = useTranslation(['common']);
  const objectToolbarEnabled = useIsFeatureFlagEnabled('object_toolbar');
  const title = t('assets.create_title');
  const tabs = useTabs({
    parentType: Parent_Type_Enum.Asset,
    parent: undefined,
    hrefRoot: '/assets/add',
    disabled: true,
  });

  return (
    <PageLayout
      title={title}
      // Object-level toolbar (CUS-157) — flag-gated. The create surface has no
      // toolbar-hosted actions and no bridged save (the form owns its own
      // Create/Cancel), so the toolbar renders title-only. ObjectToolbarView
      // only shows the Cancel X when a `save` config is present, so there's no
      // duplicate cancel control.
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={{ header: { title } }} />
        ) : undefined
      }
    >
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.Asset}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
